import type { DocumentTypeConfig } from "../types";

export const notificationDecisionConfig: DocumentTypeConfig = {
  documentType: "notification_decision",
  supportedFormats: ["pdf"],
};
